import { useCallback } from "react";
import { useApolloClient } from "@apollo/client/react";

import { overlayMutate, type BoundOverlayMutate } from "./overlayMutate";
import { useOverlayOptionId } from "./useOverlayOptionId";

/** overlayMutate with client + optionId already bound. */
export const useOverlayMutate = (): BoundOverlayMutate => {
  const client = useApolloClient();
  const overlayOptionId = useOverlayOptionId();

  return useCallback(
    (args) => overlayMutate({ client, overlayOptionId, ...args }),
    [client, overlayOptionId]
  ) as BoundOverlayMutate;
};
